module.exports = __webpack_public_path__ + "img/home-v2-3.6dcebac9.jpg";